import { Flex, Box } from "@rebass/grid/emotion"
import styled from "@emotion/styled"
import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { queries } from "@nutrafol/nutrafol-ui-kit/styles/mediaqueries"

export const QuotesWrapperFlex = styled(Flex)`
  ${queries.large`
    position: relative;
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: -0.5px;
      width: 8px;
      height: 100%;
      border-top: 1px solid ${theme.wild.color.nova.transparency.black[20]};
      border-left: 1px solid ${theme.wild.color.nova.transparency.black[20]};
      border-bottom: 1px solid ${theme.wild.color.nova.transparency.black[20]};
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    &::after {
      content: "";
      position: absolute;
      top: 0;
      right: -0.5px;
      width: 8px;
      height: 100%;
      border-top: 1px solid ${theme.wild.color.nova.transparency.black[20]};
      border-right: 1px solid ${theme.wild.color.nova.transparency.black[20]};
      border-bottom: 1px solid ${theme.wild.color.nova.transparency.black[20]};
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  `}

  &.single-quote {
    ${queries.large`
    padding-top: 24px;

    &::before {
      display: none;
    }
    &::after {
      display: none;
    }
  `}

    .quote {
      padding: 24px 8px;
      gap: 16px;

      @media (min-width: 768px) {
        padding: 24px 16px;
        flex-direction: row;
        gap: 32px;
      }

      @media (min-width: 1024px) {
        padding: 0;
      }

      .quote-image-box {
        padding: 0;
        width: 100%;

        @media (min-width: 768px) {
          width: 249px;
        }

        @media (min-width: 1024px) {
          width: 50%;
          max-width: 550px;
        }
      }

      .quote-text-box {
        width: 100%;
        padding: 0;

        @media (min-width: 768px) {
          width: calc(100% - 249px - 32px);
        }

        @media (min-width: 1024px) {
          width: calc(100% - 550px - 32px);
        }
      }
    }
  }
`

export const QuoteFlex = styled(Flex)`
  position: relative;

  @media (max-width: 1023px) {
    border-bottom: 1px solid ${theme.wild.color.nova.transparency.black[20]};
    &.first {
      border-top: 1px solid ${theme.wild.color.nova.transparency.black[20]};
    }
  }
  ${queries.large`
    height: 100%;
    flex-direction: column;
    &:not(.last) {
      border-right: 1px solid ${theme.wild.color.nova.transparency.black[20]};
    }
  `}
`

export const RightBox = styled(Box)`
  ${queries.medium`
    display: flex;
    flex-direction: column;
  `}
  ${queries.large`
    flex-grow: 1;
  `}
`
